import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungStuttgart() {
  return (
    <CityPageTemplate
      city="Stuttgart"
      slug="stuttgart"
      intro="In der Region Stuttgart mit ihrer starken Wirtschaft lohnt es sich besonders, das eigene Einkommen steueroptimiert anzulegen."
      description="Unabhängige & digitale Finanzberatung für Stuttgart: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
